import React from "react";
import { Route } from "react-router-dom";

import "./App.scss";

import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import * as userActions from './actions/userActions';
import * as menuActions from './actions/menuActions';
import * as loginActions from "./actions/loginActions";
import withMeta from './coraWebComponents/utils/withMeta';
import MetaRoute, { AuthLayout } from './coraWebComponents/meta/MetaRoute';

import Routes from "./constants/Routes";

// CoraWebComponents
import Alert from './coraWebComponents/Alert';
import LoadingPanel from './coraWebComponents/LoadingPanel';

import { connect } from 'react-redux';


// COMMON Components
import Brand from "./components/brand/Brand";
import Home from "./components/home/Home";
import Login from "./components/login/Login";
import OAuthHandler from "./components/oauth/OAuthHandler";
import Registracia from "./components/registracia/Registracia";
import User from "./components/User/User";

// Components
import AppHeader from "./zisComponents/appHeader/AppHeader";
import Dodavatel from "./components/dodavatel/Dodavatel";
import Faktury from "./components/faktury/Faktury";
import ForgotPassword from "./components/forgotPassword/ForgotPassword";
import KontaktneUdaje from "./components/kontaktneUdaje/KontaktneUdaje";
import Odberatel from "./components/odberatel/Odberatel";
import OdberatelGrid from "./components/odberatel/OdberatelGrid";
import OdberneMiesta from "./components/odberneMiesta/OdberneMiesta";
import Spotreba from "./components/spotreba/Spotreba";
import Spravy from "./components/spravy/Spravy";
import Zmluvy from "./components/zmluvy/Zmluvy";
// Components - Forms
import FormAddOdberatel from "./components/forms/formAddOdberatel/FormAddOdberatel";
import FormKontaktneUdaje from "./components/forms/formKontaktneUdaje/FormKontaktneUdaje";
import FormSettings from "./components/forms/formSettings/FormSettings";


import likelySubtags from "cldr-data/supplemental/likelySubtags.json";
import currencyData from "cldr-data/supplemental/currencyData.json";
import weekData from "cldr-data/supplemental/weekData.json";

import numbers from "cldr-data/main/sk/numbers.json";
import currencies from "cldr-data/main/sk/currencies.json";
import caGregorian from "cldr-data/main/sk/ca-gregorian.json";
import dateFields from "cldr-data/main/sk/dateFields.json";
import timeZoneNames from "cldr-data/main/sk/timeZoneNames.json";

import sk from "./coraWebComponents/res/sk.json";

// Meta
import componentFactory from "./meta/componentFactory";
import reducer from "./meta/reducer";
import akcFactory from "./meta/akcFactory";

load(likelySubtags, currencyData, weekData, numbers, currencies, caGregorian, dateFields, timeZoneNames);
loadMessages(sk, 'sk-SK');

let _init;
class App extends React.Component {
  initMenu = () => {
    this.props.meta.initMenu();
    this.forceUpdate();
  };

  handleOnClickBody = (e) => {
    // classes exist only on mobile screen
    const htmlCollection =
      document.getElementsByClassName("w-sidebar overBody");

    // if exist, sideBar expanded -> fire click event to collpase sidebar
    if (htmlCollection.length > 0) document.querySelector(".hamburger").click();
  };

  render() {
    const { isAuth, meta, msg, hideMsg } = this.props;

    if (isAuth) {
      if (!_init) {
        _init = true;
        meta.init();
      }
    } else {
      _init = false;
    }

    const header = <AppHeader />;

    const navUser = (props) => (
      <User
        uzivatel={props.uzivatel}
        onSignOut={props.onSignOut}
        userInfo={props.userInfo}
        handleOpenSettings={props.handleOpenSettings}
      />
    );

    return (
      <LocalizationProvider language="sk-SK">
        <IntlProvider locale="sk">
          <MetaRoute
            user={this.props.user}
            menu={this.props.meta.menuTree}
            menuList={this.props.meta.menu}
            isSetHomePage={true}
            initMenu={this.initMenu}
            onMenuFilter={this.props.getMenu}
            msg={'test'}
            brand={<Brand />}
            onHideMsg={() => { }}
            onSignOut={this.props.signOut}
            handleConfirmChangePassword={this.props.handleConfirmChangePassword}
            navUser={navUser}
            header={header}
            theme="default"
            themes={[{ name: "default" }]}
            updateMenu={this.initMenu}
            isNavBarNotScrollable={this.props.isAuth}
            isPath={true}
            akcFactory={akcFactory}
            componentFactory={componentFactory}
            reducer={reducer}
            loginPage={Login}
            isAuth={this.props.isAuth}
            useOverlaySidebarTypeOnExpand={true}
            onClickBody={this.handleOnClickBody}
            sideBarToggleIcons={{
              compactIcon: "k-i-reorder",
              normalIcon: "k-i-reorder",
              fullscreen: "k-i-reorder",
              hamburgerIcon: "k-i-reorder",
            }}
            customRoutes={<>
              <Route element={<AuthLayout isAuth={this.props.isAuth} key={1} />}>
                <Route element={<Home />} path={Routes.HOME} key={1} />                
                <Route element={<Spravy />} path={Routes.SPRAVY} key={7} />
                <Route element={<Dodavatel />} path={Routes.DODAVATEL} key={8} />
                <Route element={<Faktury />} path={Routes.FAKTURY} key={9} />
                <Route element={<KontaktneUdaje />} path={Routes.KONTAKTNE_UDAJE} key={10} />
                <Route element={<Odberatel />} path={Routes.ODBERATEL} key={11} />
                <Route element={<OdberneMiesta />} path={Routes.ODBERNE_MIESTA} key={12} />
                <Route element={<OdberatelGrid />} path={Routes.ODBERATELIA} key={13} />
                <Route element={<Spotreba />} path={Routes.SPOTREBA} key={13} />
                <Route element={<Zmluvy />} path={Routes.ZMLUVY} key={14} />
                <Route element={<FormAddOdberatel />} path={Routes.FORM_ADD_ODBERATEL} key={15} />
                <Route element={<FormSettings />} path={Routes.FORM_SETTINGS} key={16} />
                <Route element={<FormKontaktneUdaje />} path={Routes.FORM_ZMENA_KONTAKTNE_UDAJE} key={17} />
              </Route>
              <Route element={<Registracia />} path={Routes.REGISTRACIA} key={2} />
              <Route element={<OAuthHandler />} path={Routes.OAUTH_HANDLER} key={3} />
              <Route element={<ForgotPassword />} path={Routes.FORGOT_PASSWORD} key={4} />
            </>}
          />
        </IntlProvider>
      </LocalizationProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
    isAuth: state.user.data !== null,
    menu: window.config.menu,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleConfirmChangePassword: (newPassword) => dispatch(loginActions.changePassword({ newPassword })),
  signOut: () => dispatch(loginActions.signOut()),
  getMenu: (filter) => dispatch(menuActions.getMenu(filter)),
});

export default withMeta(connect(mapStateToProps, mapDispatchToProps)(App));
